import ResizeElementWrapper from "./ResizeElementWrapper";
import { useStore } from 'react-redux';
import ResizeElement from './ResizeElement';
import G from './Getters';
import { useContext } from 'react';
import { ColumnResizeContext } from './Contexts';

export default function CellWidthResizer({
  figurePanelId, 
  cell,
  cellResizeInfo,
  widths
}){

  if( !figurePanelId ){
    throw Error("CellWidthResizer requires `figurePanelId`");
  }

  let cellX = cell.x + cell.w - 1;
  let w = cell.w;

  const store = useStore();
  const state = store.getState();

  let resizeOptions = G.getCellResizeOptions(state,{figurePanelId,cell:[cell.y,cell.x]})
  
  return (
    <>
      <ResizeElementWrapper>
      {["left","right"].map(side => {

        if( !resizeOptions ){
          debugger;
        }

        let resizeFrom = resizeOptions[side];

      return <ResizeElement {...{
        side,
        resizeFrom,
        figurePanelId,
        cell,
        cellResizeInfo,
        cellX,
        w,
        widths
      }}/>
      })}
      </ResizeElementWrapper>
    </>
  )
  
}
